(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8618);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8420);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6159);


const DateFormatter = (param)=>{
    let { dateString  } = param;
    const date = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateString);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
        dateTime: dateString,
        children: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date, "LLLL	d, yyyy")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DateFormatter);


/***/ }),

/***/ 4396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* reexport */ PostCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/DateFormatter.tsx
var DateFormatter = __webpack_require__(2074);
// EXTERNAL MODULE: ./components/Tags/Tags.tsx + 1 modules
var Tags = __webpack_require__(2459);
;// CONCATENATED MODULE: ./components/PostCard/PostCard.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-weight: bold;\n  line-height: 32px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4px;\n  color: ",
        ";\n  font-size: 16px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n\n  * {\n    color: ",
        ";\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}





const StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2747bfd-0"
})(_templateObject());
const StyledTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-d2747bfd-1"
})(_templateObject1(), (props)=>props.theme.palette.colors.typography[1000]);
const StyledDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2747bfd-2"
})(_templateObject2(), (props)=>props.theme.palette.colors.typography[900]);
const StyledPreviewText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2747bfd-3"
})(_templateObject3(), (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.colors.typography[1000]);
const StyledTags = (0,styled_components_browser_esm/* default */.ZP)(Tags/* Tags */.$).withConfig({
    componentId: "sc-d2747bfd-4"
})(_templateObject4());
function PostCard(param) {
    let { item  } = param;
    const { title , name , date , content , slug , excerpt , tags  } = item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/posts/".concat(slug),
                style: {
                    textDecoration: "none"
                },
                title: title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDate, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateFormatter/* default */.Z, {
                                dateString: date
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPreviewText, {
                            dangerouslySetInnerHTML: {
                                __html: excerpt
                            }
                        })
                    ]
                })
            }),
            tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTags, {
                items: tags
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/PostCard/index.ts



/***/ }),

/***/ 2459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Tags; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Tags/Tag.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 8px;\n  border: 2px solid ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n  transition: background 300ms ease;\n  border-radius: 100px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 13px;\n\n  &:hover {\n    border: 2px solid ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




const StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65c913ad-0"
})(_templateObject(), (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.colors.typography[1000], (props)=>props.theme.palette.colors.purple[700], (props)=>props.theme.palette.colors.purple[700]);
const Tag = (param)=>{
    let { className , text , path  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        style: {
            textDecoration: "none",
            color: "unset"
        },
        className: className,
        title: text,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
            children: text
        })
    });
};

;// CONCATENATED MODULE: ./components/Tags/Tags.tsx

function Tags_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n"
    ]);
    Tags_templateObject = function() {
        return data;
    };
    return data;
}




const Tags_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8efdce6-0"
})(Tags_templateObject());
const Tags = (param)=>{
    let { className , items  } = param;
    if (!items) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags_StyledContainer, {
        className: className,
        children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                text: item,
                path: "/tag/".concat(item)
            }, item))
    });
};


/***/ }),

/***/ 267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getSizes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 680px;\n  margin: 0 auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const getSizes = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());


/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const MetaTags = (param)=>{
    let { title , description , url , keywords  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                "http-equiv": "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "format-detection",
                content: "telephone=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "lang",
                content: "en-US"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index,follow, max-image-preview:large"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "https://uicomponentlib.com/assets/icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "article"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "uicomponentlib.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "d3ZgGUOjRe_WaGoJEL9Xl1F7sXwIycMbyF0kQD8Sl4w"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MetaTags);


/***/ }),

/***/ 8618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9521);
/* harmony import */ var _zenury_ui_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
/* harmony import */ var _components_PostCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4396);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(267);
/* harmony import */ var _components_Tags_Tags__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2459);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5234);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8680);
/* harmony import */ var _MetaTags__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2936);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 24px 0;\n  width: 100%;\n\n  ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 28px 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  font-weight: bold;\n  color: ",
        ";\n  margin-bottom: 24px;\n  font-size: 36px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}










const StyledPosts = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2589840-0"
})(_templateObject(), _components_styles__WEBPACK_IMPORTED_MODULE_5__/* .getSizes */ .T);
const StyledDivider = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_zenury_ui_components__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .iz).withConfig({
    componentId: "sc-2589840-1"
})(_templateObject1());
const StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-2589840-2"
})(_templateObject2(), (props)=>props.theme.palette.colors.typography[1000]);
const StyledTopics = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2589840-3"
})(_templateObject3());
var __N_SSG = true;
function Home(param) {
    let { allPosts , tags  } = param;
    const { initFunc  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_7__/* .useAppContext */ .b)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        initFunc({
            posts: allPosts,
            tags
        });
    }, [
        allPosts,
        tags
    ]);
    if (!tags || !allPosts) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_MetaTags__WEBPACK_IMPORTED_MODULE_8__["default"], {
                title: _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .APP_TITLE */ .XI,
                description: _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .APP_DESCRIPTION */ .PB,
                url: _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .APP_URL */ .FX,
                keywords: _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .APP_KEYWORDS */ .pI
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPosts, {
                children: [
                    tags && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTopics, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitle, {
                                children: "Explore by topics"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Tags_Tags__WEBPACK_IMPORTED_MODULE_6__/* .Tags */ .$, {
                                items: tags
                            })
                        ]
                    }),
                    allPosts.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_PostCard__WEBPACK_IMPORTED_MODULE_4__/* .PostCard */ .y, {
                                    item: item
                                }),
                                i < allPosts.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDivider, {})
                            ]
                        }, item.slug))
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [898,358,774,888,179], function() { return __webpack_exec__(5728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);